module.exports = __webpack_public_path__ + "img/promotion_02.69c49a33.png";